import { createContext, useContext } from 'react';

import type { EventYear } from '@/data/types';

const EventContext = createContext<EventYear | null>(null);

export const EventProvider = EventContext.Provider;

/**
 * Access the active event (the one for the `:year` in the URL). Must be used within
 * an `EventLayout`, which provides the value after validating the year param.
 */
export function useEvent(): EventYear {
  const event = useContext(EventContext);
  if (!event) {
    throw new Error('useEvent must be used within an EventProvider');
  }
  return event;
}
